import React from 'react';
import * as S from './bagCancelRules.styles';

export function FareDetails({ flightItem, cardId = '' }) {
  if (
    flightItem.priceBreakup.base === null ||
    flightItem.priceBreakup.tax == null ||
    flightItem.priceBreakup.total === null
  ) {
    return null;
  }
  return (
    <div className="pad10 padB20" id={`${cardId}_fd_info`}>
      <S.Cstable className="tableFare">
        <S.Csrow>
          <S.Cscell padding="10px">
            <span className="fl" name="SRP_Details_BaseFare">
              Base Fare (1 Adult)
            </span>
          </S.Cscell>
          <S.Cscell padding="10px" name="SRP_Details_BaseFareValue">
            ₹{flightItem.priceBreakup.base}
          </S.Cscell>
        </S.Csrow>
        <S.Csrow>
          <S.Cscell padding="10px">
            <span className="fl" name="SRP_Details_TaxFare">
              Taxes and Fees (1 Adult)
            </span>
          </S.Cscell>
          <S.Cscell padding="10px" name="SRP_Details_TaxFareValue">
            ₹{flightItem.priceBreakup.tax}
          </S.Cscell>
        </S.Csrow>
        <S.Csrow>
          <S.Cscell padding="10px">
            <span className="fl 500" name="SRP_Details_TotalFare">
              Total Fare (1 Adult)
            </span>
          </S.Cscell>
          <S.Cscell padding="10px" name="SRP_Details_TotalFareValue">
            ₹{flightItem.priceBreakup.total}
          </S.Cscell>
        </S.Csrow>
      </S.Cstable>
    </div>
  );
}

export default FareDetails;
